import { Box, Typography, Button, TextField } from "@mui/material";
import { useState } from "react";

export default function CompareStudyModal({ data, onClose }) {
  const [filters, setFilters] = useState({
    id: "",
    patient: "",
    study: "",
    status: "",
    center: "",
    assigned: "",
    date: ""
  });
  const filteredData = data.filter((row) => {
    return (
      (filters.id === "" || row.id.toLowerCase().includes(filters.id.toLowerCase())) &&
      (filters.patient === "" || row.patient.toLowerCase().includes(filters.patient.toLowerCase())) &&
      (filters.study === "" || row.study.toLowerCase().includes(filters.study.toLowerCase())) &&
      (filters.status === "" || row.status.toLowerCase().includes(filters.status.toLowerCase())) &&
      (filters.center === "" || (row.center?.name || "").toLowerCase().includes(filters.center.toLowerCase())) &&
      (filters.assigned === "" || row.assigned.toLowerCase().includes(filters.assigned.toLowerCase())) &&
      (filters.date === "" || row.date.toLowerCase().includes(filters.date.toLowerCase()))
    );
  });
  const handleFilterChange = (column, value) => {
    setFilters({ ...filters, [column]: value });
  };
  return (
    <div style={overlay}>
      <Box sx={modal}>
        {/* Header */}
        <Typography variant="h6" mb={2}>
          Select study to compare
        </Typography>
        {/* Table */}
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>
                  Id
                  <TextField
                    size="small"
                    placeholder="Filter"
                    variant="outlined"
                    value={filters.id}
                    onChange={(e) => handleFilterChange("id", e.target.value)}
                    sx={{
                      display: "block",
                      mt: 1,
                      "& .MuiInputBase-root": {
                        fontSize: "0.75rem",
                        height: "32px"
                      }
                    }}
                  />
                </th>
                <th>
                  Patient
                  <TextField
                    size="small"
                    placeholder="Filter"
                    variant="outlined"
                    value={filters.patient}
                    onChange={(e) => handleFilterChange("patient", e.target.value)}
                    sx={{
                      display: "block",
                      mt: 1,
                      "& .MuiInputBase-root": {
                        fontSize: "0.75rem",
                        height: "32px"
                      }
                    }}
                  />
                </th>
                <th>
                  Study
                  <TextField
                    size="small"
                    placeholder="Filter"
                    variant="outlined"
                    value={filters.study}
                    onChange={(e) => handleFilterChange("study", e.target.value)}
                    sx={{
                      display: "block",
                      mt: 1,
                      "& .MuiInputBase-root": {
                        fontSize: "0.75rem",
                        height: "32px"
                      }
                    }}
                  />
                </th>
                <th>
                  Status
                  <TextField
                    size="small"
                    placeholder="Filter"
                    variant="outlined"
                    value={filters.status}
                    onChange={(e) => handleFilterChange("status", e.target.value)}
                    sx={{
                      display: "block",
                      mt: 1,
                      "& .MuiInputBase-root": {
                        fontSize: "0.75rem",
                        height: "32px"
                      }
                    }}
                  />
                </th>
                <th>
                  Center
                  <TextField
                    size="small"
                    placeholder="Filter"
                    variant="outlined"
                    value={filters.center}
                    onChange={(e) => handleFilterChange("center", e.target.value)}
                    sx={{
                      display: "block",
                      mt: 1,
                      "& .MuiInputBase-root": {
                        fontSize: "0.75rem",
                        height: "32px"
                      }
                    }}
                  />
                </th>
                <th>
                  Assigned
                  <TextField
                    size="small"
                    placeholder="Filter"
                    variant="outlined"
                    value={filters.assigned}
                    onChange={(e) => handleFilterChange("assigned", e.target.value)}
                    sx={{
                      display: "block",
                      mt: 1,
                      "& .MuiInputBase-root": {
                        fontSize: "0.75rem",
                        height: "32px"
                      }
                    }}
                  />
                </th>
                <th>
                  Study Date
                  <TextField
                    size="small"
                    placeholder="Filter"
                    variant="outlined"
                    value={filters.date}
                    onChange={(e) => handleFilterChange("date", e.target.value)}
                    sx={{
                      display: "block",
                      mt: 1,
                      "& .MuiInputBase-root": {
                        fontSize: "0.75rem",
                        height: "32px"
                      }
                    }}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, i) => (
                <tr key={i}>
                  <td dangerouslySetInnerHTML={{ __html: row.id }}></td>
                  <td dangerouslySetInnerHTML={{ __html: row.patient }}></td>
                  <td dangerouslySetInnerHTML={{ __html: row.study }}></td>
                  <td dangerouslySetInnerHTML={{ __html: row.status }}></td>
                  <td dangerouslySetInnerHTML={{ __html: row.center }}></td>
                  <td dangerouslySetInnerHTML={{ __html: row.assigned }}></td>
                  <td dangerouslySetInnerHTML={{ __html: row.date }}></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Footer */}
        <Box textAlign="right" mt={2}>
          <Button onClick={onClose} variant="contained">
            CLOSE
          </Button>
        </Box>
      </Box>
    </div>
  );
}
const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};
const modal = {
  width: "80%",
  background: "#fff",
  padding: "20px",
  borderRadius: "8px",
};